//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"AngleTolerance",1,0],[0,"CalculationMethod",1,0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[0,"DistanceTolerance",1,0],[1,"Length",0,"Expression",0],[0,"ShrinkMethod",1,0],[0,"UsingFactorX",1,0],[0,"UsingFactorY",1,0],[0,"UsingFactorZ",1,0],[1,"Width",0,"Expression",0],[1,"XCount",0,"Expression",0],[0,"XDirectionType",1,0],[1,"XFactor",0,"Expression",0],[1,"XPerLength",0,"Expression",0],[1,"XWidth",0,"Expression",0],[1,"YCount",0,"Expression",0],[1,"YFactor",0,"Expression",0],[1,"YPerLength",0,"Expression",0],[1,"YWidth",0,"Expression",0],[1,"ZFactor",0,"Expression",0],[1,"ZPerLength",0,"Expression",0]],[[["partName"],"RemovePart",{},1,0],[["partName"],"AddPart",{},1,0]],[]];
SPLM.Features.ShipDesign.PlatePreparationBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PlatePreparationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.PlatePreparationBuilder.ShrinkType = Object.freeze({
    "Local" : "Local", "Global" : "Global"});

export default SPLM;